import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {MembershipPlan, MembershipPlanData} from "types/MembershipPlan";
import deserializeMembershipPlan from "services/ngage/deserializers/membership-plan";
import {queryString} from "services/string";

/**
 * Get all membership plans (paginated)
 */
const all = async (page: number = 1, perPage: number = 100) => {
    const query = queryString({page, per_page: perPage})
    const response = await client.get<DataPage<MembershipPlan> | null>(`/membership-plans?${query}`)

    if (response.data) {
        response.data.data = response.data.data.map(deserializeMembershipPlan)
    }

    return response.data
}

/**
 * Get a single membership plan
 *
 * @param {number} id
 */
const get = async (id: number) => {
    return deserializeMembershipPlan(
        (await client.get<MembershipPlan>(`/membership-plans/${id}`)).data
    )
}

/**
 * Store a new membership plan
 *
 * @param data
 */
const store = async (data: MembershipPlanData) => {
    return deserializeMembershipPlan(
        (await client.post<MembershipPlan>('/membership-plans', data)).data
    )
}

/**
 * Update an existing membership plan
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: MembershipPlanData) => {
    return deserializeMembershipPlan(
        (await client.put<MembershipPlan>(`/membership-plans/${id}`, data)).data
    )
}

/**
 * Permanently delete an membership plan
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    return (await client.delete<null>(`/membership-plans/${id}`)).status === 204
}

const membershipPlans = {
    all,
    get,
    store,
    update,
    destroy
}

export default membershipPlans;